import {Pipe, PipeTransform} from '@angular/core';

type StringPipeConfig = {
	truncate?: number;
	ellipsis?: string;
	toUpperCase?: boolean;
	toLowerCase?: boolean;
};

@Pipe({
	name: 'string',
	standalone: true,
})
export class StringPipe implements PipeTransform {
	transform(value: any, config: Partial<StringPipeConfig> = {}): string {
		if (typeof value !== 'string') return value;
		let result = value;
		if (config.truncate) result = result.substring(0, config.truncate);
		if (config.ellipsis) result = result + config.ellipsis;
		if (config.toUpperCase) result = result.toUpperCase();
		if (config.toLowerCase) result = result.toLowerCase();
		return result;
	}
}
